import useModal from 'common/hooks/useModal';
import { memo } from 'react';
import BasicModal from './modal/BasicModal';

type Props = {};

const VideoEmbedModal = (props: Props) => {
  const { handleCloseVideo, embedUrl, showVideoModal } = useModal();
  return (
    <BasicModal
      sx={{
        width: '750px',
        aspectRatio: '16/9',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin: 0,
        padding: 0,
      }}
      open={showVideoModal}
      onClose={handleCloseVideo}
    >
      <iframe
        src={embedUrl}
        width="100%"
        height="100%"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Embedded youtube"
      />
    </BasicModal>
  );
};

export default memo(VideoEmbedModal);
